import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  spacing = theme.spacing,
  text = theme.text;
export var blocksHeaderWrapper = /*#__PURE__*/css(["margin:0 0 ", ";border-radius:", ";width:100%;background:var(--neutral-white-base);text-align:left;transition:border-color 0.15s ease-in,background-color 0.15s ease-in;position:relative;color:var(--neutral-black-base);font-family:", ";", ";"], pxToRem(spacing.xs), pxToRem(10), fonts.PRIMARY_REGULAR.family, fontSize(text.BODY.XS));